import { formatCellParamName } from '@utils/formatCellParamName';

export const prepareCellData = (data: Record<string, any>): Record<string, string> => {
	return Object.entries(data).reduce((acc: Record<string, string>, [key, value]) => {
		if (
			key === 'assetId' ||
			key === 'cellId' ||
			key === 'createdAt' ||
			key === 'crowdCellId' ||
			key === 'id' ||
			key === 'lat' ||
			key === 'lng' ||
			key === 'ownerId' ||
			key === 'siteId' ||
			key === 'updatedAt' ||
			key === 'enodeBId' ||
			key === 'gnodeBId' ||
			key === 'siteDbId' ||
			!value
		) return acc;

		const formattedKey = formatCellParamName(key, [
			'id',
			'tac',
			'pci',
			'earfcn',
			'mcc',
			'mnc',
			'dl',
			'ul',
		]);

		if (typeof value === 'object') {
			acc[formattedKey] = (value?.title || value?.name || value?.value || value?.id)?.toString() || 'N/A';
		} else {
			acc[formattedKey] = value?.toString() || 'N/A';
		}

		return acc;
	}, {});
};
